module.exports = __webpack_public_path__ + "static/OpenSans-Italic-ade4c07ce71298f5a48785ece6a8c968.woff2";